import { createVNode as a, mergeProps as n } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NoResult2TwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(d, n(e, {
    icon: s
  }), null);
};
t.displayName = "NoResult2TwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
